import React from "react";

function Card1() {
  return (
    <>
      <div className="test" style={{ margin: "12px auto" }}></div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
      }}
    >
      <div className="card-basic">
        <div className="img">
          <img
            src="https://img.gymshark.com/image/fetch/q_auto,f_auto,w_600/https://cdn.shopify.com/s/files/1/1367/5201/products/RESTOREJACKETBLACK.A-Edit_ZH_ZH_f5587b6a-470d-47b1-88b5-10ef6dd83102.jpg?v=1614086813"
            alt=""
          />
          <span className="cardBadge">New Arrival</span>
        </div>
        <div className="description">
          <div className="descriptionLeft">Arrival-Tshirt</div>
          <div className="descriptionRight">
            <h2>20$</h2>
          </div>
        </div>

        <div className="footer">Black</div>
        </div>
        
        {/*-----------------------------------------------------------------------------------*/}
      <div className="card-dismiss">
        <div className="img">
          <img
            src="https://img.gymshark.com/image/fetch/q_auto,f_auto,w_600/https://cdn.shopify.com/s/files/1/1367/5201/products/COMPOUNDSHORTCAMOGREEN.A-Edit_ZH.jpg?v=1613985620"
            alt=""
          />
          <div className="cardDismiss">
            <i class="far fa-times-circle"></i>
          </div>
        </div>
        <div className="description">
          <div className="descriptionLeft">Arrival-Shorts</div>
          <div className="descriptionRight">
            <h2>20$</h2>
          </div>
        </div>

        <div className="footer">Black</div>
        </div>
        
             {/*-----------------------------------------------------------------------------------*/}
      <div className="card-text-overlay">
        <div className="img">
          <img
            src="https://images.pexels.com/photos/1431282/pexels-photo-1431282.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt=""
          />
        </div>
        <div className="card-description">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur
            Puta madre minima Lorem ipsum, dolor sit amet consectetur
            adipisicing elit. Excepturi et amet vero.
          </p>
        </div>
        </div>
             {/*  */}
      <div className="card-profile">
        <div className="card-profile-top">
          <div className="card-profile-left">
            <div className="avatar round-xs">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/8/89/Chris_Evans_2020_%28cropped%29.jpg"
                alt=""
              />
            </div>
            <div className="card-profile-top-left-name">
              <p>Shrimp and Chozio Pella</p>
              <p>septmeber 14 2020</p>
            </div>
          </div>
          <div className="card-profile-top-right">
            <i class="fas fa-ellipsis-v"></i>
          </div>
        </div>
        <div className="card-profile-image">
          <img
            src="https://im.whatshot.in/img/2018/Nov/is-image-1-pre-cropped-1542960293.jpg"
            alt=""
          />
        </div>
        <div className="card-profile-description">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Modi ut
          obcaecati qui tempora iste commodi doloremque, laudantium architecto
          impedit id!
        </div>
        <div className="card-profile-footer">
          <div className="card-profile-footer-left">
            <i class="fas fa-heart"></i>
            <i class="fas fa-share-alt"></i>
          </div>
        </div>
        </div>
        
            {/*-----------------------------------------------------------------------------------*/}

      <div className="card-profile shadow">
        <div className="card-profile-top">
          <div className="card-profile-left">
            <div className="avatar round-sm">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/8/89/Chris_Evans_2020_%28cropped%29.jpg"
                alt=""
              />
            </div>
            <div className="card-profile-top-left-name">
              <p>Shrimp and Chozio Pella</p>
              <p>septmeber 14 2020</p>
            </div>
          </div>
          <div className="card-profile-top-right">
            <i class="fas fa-ellipsis-v"></i>
          </div>
        </div>
        <div className="card-profile-image">
          <img
            src="https://im.whatshot.in/img/2018/Nov/is-image-1-pre-cropped-1542960293.jpg"
            alt=""
          />
        </div>
        <div className="card-profile-description">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Modi ut
          obcaecati qui tempora iste commodi doloremque, laudantium architecto
          impedit id!
        </div>
        <div className="card-profile-footer">
          <div className="card-profile-footer-left">
            <i class="fas fa-heart"></i>
            <i class="fas fa-share-alt"></i>
          </div>
        </div>
      </div>

             {/*-----------------------------------------------------------------------------------*/}

      <div className="card-profile shadow-xl">
        <div className="card-profile-top">
          <div className="card-profile-left">
            <div className="avatar round-sm">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/8/89/Chris_Evans_2020_%28cropped%29.jpg"
                alt=""
              />
            </div>
            <div className="card-profile-top-left-name">
              <p>Shrimp and Chozio Pella</p>
              <p>septmeber 14 2020</p>
            </div>
          </div>
        </div>
        <div className="card-profile-description">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Modi ut
          obcaecati qui tempora iste commodi doloremque, laudantium architecto
          impedit id! Lorem ipsum dolor sit amet consectetur, adipisicing elit.
          Modi ut obcaecati qui tempora iste commodi doloremque, laudantium
          architecto impedit id! Lorem ipsum dolor sit amet consectetur,
          adipisicing elit. Modi ut obcaecati qui tempora iste commodi
          doloremque, laudantium architecto impedit id! Lorem ipsum dolor sit
          amet consectetur, adipisicing elit. Modi ut obcaecati qui tempora iste
          commodi doloremque, laudantium architecto impedit id!
        </div>
        </div>
        
            {/*-----------------------------------------------------------------------------------*/}
    
      </div>
      <div className="test" style={{ marginTop: "19px" }}></div>
      
        {/*-----------------------------------------------------------------------------------*/}
      <div className="card-horizontal">
        <div className="card-horizontal-left">
          <img
            src="https://cache.desktopnexus.com/thumbseg/498/498008-bigthumbnail.jpg"
            alt=""
          />
        </div>
        <div className="card-horizontal-right">
          <div className="card-horizontal-right-name">
            Jane Doe
          </div>
          <div className="card-horizontal-right-title">
         <h3>Boxing icon has the will for a couple more fights</h3>   
          </div>
          <div className="card-horizontal-right-description">
            Boxing icon has the will for a couple more fights
             Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reiciendis est quibusdam, officia ratione molestias porro corrupti mollitia harum quasi aperiam nesciunt accusantium cumque eum. Quaerat quidem esse tenetur modi distinctio?
          </div>
          
        </div>
      </div>

      <div className="descrip" style={{ margin: "0rem 1rem" }}>
        <div className="heading">
          <h2 style={{ margin: "0rem 1rem" }}> Cards</h2>
          <p style={{ margin: "0.5rem 1rem" }}>
            {" "}
          There are 6 different cards bases on their style and content distribution which can be seen above
          </p>
         
          <p style={{ margin: "0.5rem 1rem" }}>
            1) First one is a Card With badge on it to notify user or to highlight the card which has some kind of information
          </p>
          <p style={{ margin: "0.5rem 1rem" }}>
            2) Second card is slightly same as first card as first with few difference such as, there is an close icon at top right to close the card and the size of the card is slightly lower than other card
          </p>
          <p style={{ margin: "0.5rem 1rem" }}>
            3) third  one is an text overlay card which has alll the information about the card on the image itself 
          </p>
          <p style={{ margin: "0.5rem 1rem" }}>
            4) Fourth one is fully fledged card which has numerous information starting from useers avatar,name and a content with picture and description and lastly there are few incons to perform further actions on card
          </p>
          <p style={{ margin: "0.5rem 1rem" }}>
            5) Fifth card is same as fourth card except there is an background color on the card
          </p>
          <p style={{ margin: "0.5rem 1rem" }}>
            6) sixth card is same as fourth card excepr there is a box shadown on the card
            
          </p>
          <p style={{ margin: "0.5rem 1rem" }}>
            7) seventh card is slightly differrent from other cards, the content on the card is horizontal unlike other cards which are verticlly aligned.
            
          </p>
        </div>
      </div>
      <iframe src="https://www.thiscodeworks.com/embed/605c42ca2476f700148cf8b5" style={{ width: "70%", height: "16rem", display: "block", margin: "1rem auto", border: "none", minWidth: "23rem" }}></iframe>

      <iframe src="https://www.thiscodeworks.com/embed/605c43412476f700148cf8b6" style={{ width: "70%", height: "16rem", display: "block", margin: "1rem auto", border: "none", minWidth: "23rem" }}></iframe>

      <iframe src="https://www.thiscodeworks.com/embed/605c43712476f700148cf8b7" style={{ width: "70%", height: "16rem", display: "block", margin: "1rem auto", border: "none", minWidth: "23rem" }}></iframe>

      <iframe src="https://www.thiscodeworks.com/embed/605c43bb2476f700148cf8b8" style={{ width: "55%", height: "32rem", display: "block", margin: "1rem auto", border: "none", minWidth: "23rem" }}></iframe>

      <iframe src="https://www.thiscodeworks.com/embed/605c44192476f700148cf8b9" style={{ width: "55%", height: "32rem", display: "block", margin: "1rem auto", border: "none", minWidth: "23rem" }}></iframe>

      <iframe src="https://www.thiscodeworks.com/embed/605c44af2476f700148cf8ba" style={{ width: "55%", height: "32rem", display: "block", margin: "1rem auto", border: "none", minWidth: "23rem" }}></iframe>
      


   
</>
  );
}

export default Card1;
